import React from 'react';
import PropTypes from 'prop-types';

import {
  Root,
  ImageContainer,
  BrandLink,
  Name,
  Role,
  SocialLink,
  Bio,
} from './ArtistCard.style';

export const ArtistCard = ({
  imageSrc,
  brand,
  name,
  role,
  socialHandle,
  socialLink,
  bio,
}) => {
  return (
    <Root>
      <ImageContainer>
        <img src={imageSrc} alt={name} />
      </ImageContainer>
      <BrandLink to={`/brands/${brand}`}>{brand}</BrandLink>
      <Name>{name}</Name>
      <Role>{role}</Role>
      <SocialLink href={socialLink} target="_blank" rel="noopener noreferrer">
        {socialHandle}
      </SocialLink>
      {bio && <Bio>{bio}</Bio>}
    </Root>
  );
};

ArtistCard.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  socialHandle: PropTypes.string.isRequired,
  socialLink: PropTypes.string.isRequired,
  bio: PropTypes.string,
};
